import styled from 'styled-components/macro';

import { DropdownSelect } from '../../common/formElements';
import * as colors from 'components/common/colorConstants';
import { Subtext } from '../Popups.styles';

export const CustomInput = styled.input`
  width: 100%;
  height: 24px;
  appearance: none;
  padding: 0 20px 0 7px;
  border: 1px solid #4697c3;
  border-radius: 4px;
  outline: none;
  color: ${colors.blackText};
  font-size: 11px;
  margin-top: 20px;

  ::placeholder {
    color: ${colors.formInputTextForFilledBack};
  }
`;

export const DropdownReason = styled(DropdownSelect)`
  margin-bottom: 0;
  color: ${colors.blackText};
  font-size: 11px;

  > option[disabled] {
    color: ${colors.formInputTextForFilledBack};
  }
`;

export const WarningMessage = styled(Subtext)`
  margin: 20px 0;
  text-align: left;
`;
